import { render, staticRenderFns } from "./RoleTable.vue?vue&type=template&id=0b940788"
import script from "./RoleTable.vue?vue&type=script&lang=ts"
export * from "./RoleTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports